import { useDispatch, useSelector } from "react-redux";
import "./TrendingPosts.css";
import { useEffect } from "react";
import { getTrendingPosts } from "../../redux/actions/postActions";
import FeedItem from "../Feed/FeedItem";
import { SectionSeparator } from "../Separator";

const TrendingPosts = () => {
  const dispatch = useDispatch();
  const { trendingPosts, modifiedPost } = useSelector((state) => state.post);

  // useEffect(() => {
  //   dispatch(getTrendingPosts(1));
  // }, [dispatch]);
  useEffect(() => {
    // 1. Fetch immediately
    dispatch(getTrendingPosts(1));

    // 2. Set up an interval to fetch quietly in the background (e.g., every 1 hour)
    const ONE_HOUR_MS = 1000 * 60 * 60;
    const interval = setInterval(() => {
      dispatch(getTrendingPosts(1));
    }, ONE_HOUR_MS);

    // 3. Clean up the interval on unmount
    return () => clearInterval(interval);
  }, [dispatch]);
  if (!trendingPosts || (trendingPosts && trendingPosts.length === 0))
    return null;
  return (
    <div className="trending-posts-wrapper">
      <h2 className="trending-posts__title">
        <span>🔥</span> <span>Trending Today </span>
      </h2>
      <div className="trending-posts__content">
        {trendingPosts.map((post) => (
          <div key={post._id}>
            <FeedItem
              post={post}
              isReposted={post.type !== "post"}
              index={post._id}
            />
            <SectionSeparator />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrendingPosts;
